
//importaciones de componentes
import { Button, Divider, FormControl, Grid, TextField } from '@mui/material'

export const CollateralRealEstate = ({ useFetchInit }) => {

    const {
        //------------- globalStates
        globalStates,
        //------------- Formularios
        Forms,
    } = useFetchInit

    // ------------------------------------------------ Generales

    // ------------------------------------------------ globalStates
    const { modalOpeningMode } = globalStates

    // ------------------------------------------------ Formularios
    const { FormCollateral: { formState, onInputChange } } = Forms


    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="estate">* Finca</label>
                        <TextField
                            id='estate'
                            name='estate'
                            value={formState.estate}
                            onChange={onInputChange}
                            size='small'
                            placeholder='Finca'
                            hiddenLabel
                            type='text'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="folio">* Folio</label>
                        <TextField
                            id='folio'
                            name='folio'
                            value={formState.folio}
                            onChange={onInputChange}
                            size='small'
                            placeholder='Folio'
                            hiddenLabel
                            type='text'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="book">* Libro</label>
                        <TextField
                            id='book'
                            name='book'
                            size='small'
                            type='text'
                            placeholder='Libro'
                            hiddenLabel
                            value={formState.book}
                            onChange={onInputChange}
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="department">* Departamento</label>
                        <TextField
                            id='department'
                            name='department'
                            size='small'
                            type='text'
                            placeholder='Departamento'
                            hiddenLabel
                            value={formState.department}
                            onChange={onInputChange}
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>

        </>
    )
}
